export default {
    initFullImageTextSlider() {
        $('.full-image-text-slider-block--slider').slick({
            infinite: true,
            slidesToShow: 1,
            arrows: true,
        });
    },

    initImageSlider() {
        $('.image-slider-block--slider').slick({
            infinite: true,
            slidesToShow: 3.7,
            arrows: true,
            responsive: [
                {
                    breakpoint: 900,
                    settings: {
                        slidesToShow: 2.7,
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1.7,
                    }
                },
            ]
        });
    },
}